import { useIntl } from "react-intl"
import type { CaseNarrative, Section, SectionLabels } from "@/types/exams"

const ORDER: Section[] = ["intake", "session_1", "session_2"]
const FIELDS: Record<Section, keyof CaseNarrative> = {
  intake: "intake_summary",
  session_1: "session_1",
  session_2: "session_2",
}

/**
 * The case narrative up to the current question's section. Earlier sections
 * stay available but start collapsed, so the newest information is in view.
 */
export function CasePanel({
  caseStudy,
  section,
  labels,
}: {
  caseStudy: CaseNarrative
  section: Section
  labels: SectionLabels
}) {
  const intl = useIntl()
  const revealed = ORDER.slice(0, ORDER.indexOf(section) + 1)

  return (
    <div className="callout">
      <h2>{caseStudy.title}</h2>
      {caseStudy.presenting_concern && <p className="mt-1 text-sm text-ink-muted">{caseStudy.presenting_concern}</p>}
      <div className="mt-4 space-y-3">
        {revealed.map((s) => {
          const text = caseStudy[FIELDS[s]] as string | null
          return (
            <details key={`${caseStudy.id}-${s}-${section}`} open={s === section}>
              <summary className="cursor-pointer text-sm font-medium text-ink-display">{labels[s]}</summary>
              <p className="mt-2 whitespace-pre-wrap">{text || intl.formatMessage({ id: "exams.no_section_text" })}</p>
            </details>
          )
        })}
      </div>
    </div>
  )
}
